@import "~@govbr-ds/core/src/components/switch/switch";

:host {
  display: block;
}
